export default {
  titles: {
    pickup: 'Abholung',
    delivery: 'Lieferung',
  },
  buttons: {
    confirm: 'Bestätigen',
  },
};
